<template>
  <router-view />
</template>

<script>
export default {
  name: "virtualView",
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.$store.dispatch("Setup/getReviewChecklist");
    });
  },
};
</script>

<style scoped></style>
